var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-main"},[_c('div',{staticStyle:{"margin-right":"-1px","width":"18px"}},[_c('i',{staticClass:"icon iconfont icon-guanbi",on:{"click":function($event){$event.stopPropagation();return _vm.closePreview($event)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }